export default {
  admin: 'ADMIN',
  user: 'USER',
  loan_approval: 'LOAN_APPROVAL',
  repayment_management: 'REPAYMENT_MANAGEMENT',
  client_user_management: 'CLIENT_USER_MANAGEMENT',
  admin_user_management: 'ADMIN_USER_MANAGEMENT',
};
